import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled, { ThemeProvider } from 'styled-components';

import theme from '../stylesheets/theme';

import Layout from './layout';
import SeeMoreCamps from './seeMore/camps';

const CampHOCStyles = styled.div`
  width: 100vw;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  .img-camp-hero {
    margin: 58px auto 0;
    width: 100%;
    height: 80vh;
    background-size: cover;
  }
  .camp-content {
    margin: 0 auto;
    width: 100vw;
    margin-bottom: 10px;
    display: flex;
    flex-direction: column;
    .offering-img {
      max-width: 1200px;
      /* max-height: 800px; */
      width: 100%;
      margin: 35px auto;
      @media (min-width: 775px) {
        margin: 50px auto;
      }
    }
    .offering-img-row {
      width: 100%;
      max-width: 1200px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      margin: 0 auto;
      .offering-img-vert {
        max-height: 100vh;
        max-height: 800px;
        height: 100%;
        width: calc(50% - 12.5px);
        margin: 50px 0;
      }
    }
    .camp-text-content {
      max-width: 800px;
      max-width: 90vw;
      margin: 0 auto;
      h2 {
        color: ${(props) => props.theme.black};
        text-align: center;
        text-transform: uppercase;
        max-width: 800px;
        margin: 36px auto 24px;
      }
      h3 {
        color: ${(props) => props.theme.black};
        text-align: center;
        max-width: 800px;
        margin: 0 auto 24px;
      }
      h4 {
        margin-top: 25px;
        max-width: 800px;
        margin: 0 auto;
      }
      p {
        max-width: 800px;
        margin: 0 auto;
      }
      a {
        color: ${(props) => props.theme.blue};
      }
      span {
      }
      .bolded {
        font-weight: bold;
      }
    }
    .break-line {
      border: 1px solid rgba(0, 0, 0, 0.3);
      margin-top: 50px;
      max-width: 800px;
    }
    .fb-group {
      border-top: 2px solid rgba(0, 0, 0, 0.3);
      border-bottom: 2px solid rgba(0, 0, 0, 0.3);
      margin: 50px 0 0;
      padding: 50px 0;
      font-weight: bold;
      font-size: 16px;
      text-align: center;
      max-width: 800px;
    }
  }
`;

// eslint-disable-next-line react/prop-types
const CampHoc = ({ seo, camp, heroImage, children, objectPosition }) => (
  <Layout seo={seo}>
    <ThemeProvider theme={theme}>
      <CampHOCStyles className="camp">
        <GatsbyImage
          image={heroImage}
          imgStyle={objectPosition}
          className="img-camp-hero"
          alt="image"
        />
        <div className="camp-content">{children}</div>
      </CampHOCStyles>
      <SeeMoreCamps camp={camp} />
    </ThemeProvider>
  </Layout>
);

export default CampHoc;
